import { Pipe, PipeTransform } from '@angular/core';
import { ServiceType } from '../constants/service-type';

@Pipe({
  name: 'serviceType'
})
export class ServiceTypePipe implements PipeTransform {
  transform(type: ServiceType): { label: string; color: string } {
    switch (type) {
      case ServiceType.ROUTING_SERVICE:
        return { label: 'Routing Service', color: 'lincolngreen' };
      case ServiceType.KYC_SERVICE:
        return { label: 'KYC Service', color: 'secondary' };
      case ServiceType.FRAUD_PREVENTION_SERVICE:
        return { label: 'Fraud Prevention Service', color: 'indianred' };
      default:
        return { label: '-', color: 'secondary' };
    }
  }
}
